import { useHistory } from 'react-router-dom'

import { Banner } from '@loadsmart/miranda-react'

type ReviewAwardedLanesBannerProps = {
  rfpId: string
}

export function ReviewAwardedLanesBanner({ rfpId }: ReviewAwardedLanesBannerProps) {
  const { push: navigate } = useHistory()

  function handleReviewClick() {
    navigate(`/portal/rfp/${rfpId}/award`)
  }

  return (
    <Banner variant="warning">
      <Banner.Title>{`You have awarded bids. Please review the bids to accept or reject the award.`}</Banner.Title>
      <Banner.Actions>
        <Banner.ActionPrimary onClick={handleReviewClick}>{`Review bids`}</Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  )
}
